export enum NavigationBarVariant {
  default = "default",
  light = "light",
  white = "white",
  blog = "blog",
  dark = "dark",
  indigo = "indigo",
  indigoGradient = "indigo-gradient"
}

export enum FooterVariant {
  default = "default",
  light = "light",
  dark = "dark"
}

export interface NavigationBarDropdownItem {
  to?: string;
  title?: string;
  text?: string;
  link?: string;
  icon?: React.ReactElement;
  badgeText?: string;
  disabled?: boolean;
  nofollow?: boolean;
  onClick?: () => void;
  itemId?: string;
}

export interface NavigationBarItem {
  to?: string;
  title: string;
  dropdownRows?: NavigationBarDropdownItem[];
  subMenu?: NavigationBarDropdownItem[];
  link?: string;
  itemId?: string;
  node_locale?: string;
  nodes: any;
}
